/**
 * Stake wordmark for the sidebar — the asset is already white-on-transparent,
 * so it drops straight onto the rail next to the lucide icons.
 */
export default function StakeLogo({ size = 19, className = '' }: { size?: number; className?: string }) {
    return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
            src="/img/logos/stakecom.svg"
            alt="Stake"
            width={size}
            height={size}
            style={{ width: size, height: size }}
            className={`object-contain ${className}`}
        />
    );
}
